/* Momeaze — thumbnail ↑↓ (desktop) / ‹› (mobile) = previous / next image */
(function () {
  'use strict';
  if (window.MzThumbNav) return;
  window.MzThumbNav = true;

  var EDGE = 44; // mobile arrows overlap the first/last thumbnails

  function sliderOf(btn) {
    var s = btn.closest('slider-component');
    return s && s.querySelector('.thumbnail-list') ? s : null;
  }

  // Visible thumbnails only (variant filtering can hide some)
  function thumbs(slider) {
    var list = slider.querySelector('.thumbnail-list');
    if (!list) return [];
    return Array.prototype.filter.call(list.children, function (li) {
      return li.offsetParent !== null && li.querySelector('button');
    });
  }

  function currentIndex(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].querySelector('button').getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  // Nearest ancestor that clips and overflows on the given axis
  function axisScroller(el, slider, horizontal) {
    while (el) {
      var cs = getComputedStyle(el);
      var o = horizontal ? cs.overflowX : cs.overflowY;
      var over = horizontal ? el.scrollWidth > el.clientWidth + 1 : el.scrollHeight > el.clientHeight + 1;
      if (o !== 'visible' && over) return el;
      if (el === slider) break;
      el = el.parentElement;
    }
    return null;
  }

  function reveal(item, slider) {
    var list = item.parentElement;
    var r = item.getBoundingClientRect();

    var sy = axisScroller(list, slider, false);
    if (sy) {
      var s = sy.getBoundingClientRect();
      if (r.top < s.top) sy.scrollBy({ top: r.top - s.top - 4, behavior: 'smooth' });
      else if (r.bottom > s.bottom) sy.scrollBy({ top: r.bottom - s.bottom + 4, behavior: 'smooth' });
    }

    var sx = axisScroller(list, slider, true);
    if (sx) {
      var h = sx.getBoundingClientRect();
      if (r.left < h.left + EDGE) sx.scrollBy({ left: r.left - h.left - EDGE, behavior: 'smooth' });
      else if (r.right > h.right - EDGE) sx.scrollBy({ left: r.right - h.right + EDGE, behavior: 'smooth' });
    }
  }

  function sync(slider) {
    var prev = slider.querySelector('.slider-button--prev');
    var next = slider.querySelector('.slider-button--next');
    if (!prev || !next) return;
    var items = thumbs(slider);
    var i = currentIndex(items);
    // Dawn's slider logic keeps disabling these
    prev.removeAttribute('disabled');
    next.removeAttribute('disabled');
    prev.classList.toggle('mz-end', i <= 0);
    next.classList.toggle('mz-end', i >= items.length - 1);
  }

  function syncAll() {
    document.querySelectorAll('slider-component').forEach(function (s) {
      if (s.querySelector('.thumbnail-list')) sync(s);
    });
  }

  // Capture phase: runs before Dawn's own click handler
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.slider-button');
      if (!btn) return;
      var slider = sliderOf(btn);
      if (!slider) return;

      e.preventDefault();
      e.stopPropagation();

      var items = thumbs(slider);
      if (!items.length) return;
      var dir = btn.classList.contains('slider-button--prev') || btn.name === 'previous' ? -1 : 1;
      var n = currentIndex(items) + dir;
      if (n < 0 || n >= items.length) return;

      items[n].querySelector('button').click(); // MediaGallery switches the main image
      reveal(items[n], slider);
      setTimeout(syncAll, 60);
    },
    true
  );

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      syncAll();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncAll();
    new MutationObserver(queueSync).observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-current'],
    });
  });
  window.addEventListener('load', function () {
    syncAll();
    setTimeout(syncAll, 400);
  });
  window.addEventListener('resize', queueSync);
})();